import emailLinkSuccessSrc from '@corbado/shared-ui/assets/email-link-success.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const EmailLinkSuccessIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, emailLinkSuccessSrc, '--cb-primary-color');
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'device-icon', ...props }));
});
